import createIcon from '../../createIcon';

/**
 * @component @name CallMissed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNTkgNi43OTQ5MkwxMiAxNC4zODQ5TDYuNDEgOC43OTQ5MkgxMVY2Ljc5NDkySDNWMTQuNzk0OUg1VjEwLjIwNDlMMTIgMTcuMjA0OUwyMSA4LjIwNDkyTDE5LjU5IDYuNzk0OTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CallMissed = createIcon('CallMissed', [
  [
    'path',
    {
      d: 'M19.59 6.79492L12 14.3849L6.41 8.79492H11V6.79492H3V14.7949H5V10.2049L12 17.2049L21 8.20492L19.59 6.79492Z',
      key: '1dwlnk',
    },
  ],
]);

export default CallMissed;
